<div class="card card-statistics mb-30">
  <div class="card-body">
      <h5 class="card-title" *ngIf="inner_Evaluate.id==0">Add Evaluation Question</h5>
      <h5 class="card-title" *ngIf="inner_Evaluate.id>0">Edit Evaluation Question</h5>
      <form [formGroup]="FormEvaluate" (submit)="SubmitFormEvaluate()">

        <input type="hidden" formControlName="id" />

        <div class="row">
          <div class="form-group col-md-12">
            <label for="exampleInputEmail1">Title</label>
            <textarea formControlName="Title" type="text" class="form-control"  placeholder="Type here...">

            </textarea>
            <small *ngIf="!get_Form_Title().valid && get_Form_Title().touched" class="form-text text-muted MyErrorRedColor">Enter the title.</small>
          </div>
        </div>
        <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
        <button *ngIf="!InProccessing && inner_Evaluate.id==0" type="submit" [disabled]="!FormEvaluate.valid" class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Save </button>
        <button *ngIf="!InProccessing && inner_Evaluate.id>0" type="submit" [disabled]="!FormEvaluate.valid" class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-edit"></i> Edit </button>

      </form>
  </div>
</div>
